import * as React from 'react'
import { connect } from 'react-redux'
import * as WpsRuntime from 'DVWebNodeWpsRuntime'
import { PurchaseButton, PrimeButton, ButtonProps } from '@amzn/dvui/dist/Button'
import { Text } from '@amzn/dvui/dist/Text'
import * as cn from 'classnames'
import { sanitizedRequestContextSelector } from '../../selectors/requestContext'
import { IDetailPageState } from '../../reducers'
import * as utilityClasses from '../utilityClasses.module.scss'
import { AtfTreatmentProps } from '../../reducers/features'
import { isTreatment } from '../../utils/utils'
import * as st from './acquisition.module.scss'

type ISvodButton = {
  svodAction: WpsRuntime.atv.wps.SubscribeActionProps
  className?: string
  forceDoubleHeight?: boolean
} & ReturnType<typeof mapStateToProps> & AtfTreatmentProps

export const ConnectedSvodButton = ({ svodAction, requestContext: { isRetail }, className, forceDoubleHeight,
                                      atfTreatment}: ISvodButton) => {
  const Tag =
    svodAction.sType === 'PRIME' && !isRetail ? PrimeButton : PurchaseButton

  const atfTreatmentProps: ButtonProps = {
    ...(isTreatment(atfTreatment,'T1', 'T2', 'T3') && { forceDoubleHeight: false }),
    ...(isTreatment(atfTreatment,'T1', 'T3') && { shape: 'pill' })
  }
  return (
    <Tag
      className={cn({ [className!]: !!className }, utilityClasses.fullWidthPhablet, 'dv-signup-button',
        {[st.centerButton]: isTreatment(atfTreatment,'T1', 'T2', 'T3')})}
      href={svodAction.signupLink}
      forceDoubleHeight={forceDoubleHeight}
      {...atfTreatmentProps}
    >
      <Text string={svodAction.label} />
    </Tag>
  )
}

const mapStateToProps = (state: IDetailPageState) => ({
  requestContext: sanitizedRequestContextSelector(state)
})

export const SvodButton = connect(mapStateToProps)(ConnectedSvodButton)
